import { Injectable } from '@angular/core';

@Injectable()
export class Formvalidator {

    formValidation: any;
    numberSpaceChar = new RegExp("^[A-Öa-ö0-9 -]*[A-Öa-ö0-9][A-Öa-ö0-9 -]*$");

    constructor() {
        this.setDefault();
    }

    setDefault(){
        this.formValidation = {
            govNameError: false,
            govPhoneError: false,
            govPostAddressError: false,
            govCityError: false,
            govPostNumberError: false,
            compProjectError: false,
            govSupplierError: false,
            compSecChiefError: false,
            compSecChiefPhone: false,
            compSecondSecChiefError: false,
            compSecondSecChiefPhone: false,
            secContractError: false,
            rkError: false,
            projectDateError: false
        }
    }

    validateProjectForm(suaForm, modalData = ["", ""]) { 
        modalData[0] = "Valideringsfel";
        modalData[1] = "Vi kunde inte hitta vad som gick fel."; 
        if(!this.validateGovName(suaForm.govFullName, modalData)
                && !this.validateGovPostAddress(suaForm.govPostAddress, modalData)
                && !this.validateGovPhone(suaForm.govPhone, modalData)
                && !this.validateGovPostCity(suaForm.govPostCity, modalData)
                && !this.validateGovPostNumber(suaForm.govPostNumber, modalData)

                && !this.validateCompProject(suaForm.compProjectName, modalData)
                && !this.validateGovSupplier(suaForm.compSupplier, modalData)
                && !this.validateCompSecChief(suaForm.compSecChief, modalData)
                && !this.validateCompSecChiefPhone(suaForm.compSecPhoneNumber, modalData)
                && !this.validateSecondCompSecChief(suaForm.compSecondSecChief, modalData)
                && !this.validateSecondCompSecChiefPhone(suaForm.compSecondSecPhoneNumber, modalData)
                && !this.validateSecContractSelected(suaForm.compSecContractLevel, modalData)
                && !this.validateRegisterControl(suaForm.regControl, modalData)
                && !this.validateProjectDate(suaForm.compSecContractDate, modalData)
            ) {
                return true;
            }
            return false;
    }

    /**
     * Validate government 
     * @param input Government name
     * @param modalData Error modal
     */
    validateGovName(input, modalData = ["", ""]) {
        if(input === null || input === "") {
            modalData[0] = "Fel i fält: Myndighetens namn";
            modalData[1] = "Fältet får inte vara tom.";
            return this.formValidation.govNameError = true;
        }
        if(input != null && this.numberSpaceChar.test(input)) {
            return this.formValidation.govNameError = false;
        } else {
            modalData[0] = "Fel i fält: Myndighetens namn";
            modalData[1] = "Fältet får endast innehålla siffror eller karaktärer.";
            return this.formValidation.govNameError = true;
        }
    }

    /**
     * Validate government address
     * @param input Government address
     * @param modalData Error modal
     */
    validateGovPostAddress(input, modalData = ["", ""]) {
        if(input === null || input === "") {
            modalData[0] = "Fel i fält: Postadress (myndighet)";
            modalData[1] = "Fältet får inte vara tom.";
            return this.formValidation.govPostAddressError = true;
        }
        if(input != null && this.numberSpaceChar.test(input)) {
            return this.formValidation.govPostAddressError = false;
        } else {
            modalData[0] = "Fel i fält: Postadress (myndighet)";
            modalData[1] = "Fältet får endast innehålla siffror eller karaktärer.";
            return this.formValidation.govPostAddressError = true;
        }
    }

    /**
     * Validate government phone 
     * @param input Government phone
     * @param modalData Error modal
     */
    validateGovPhone(input, modalData = ["", ""]) {
        if(input === null || input === "") {
            modalData[0] = "Fel i fält: Telefonnummer (myndighet)";
            modalData[1] = "Fältet får inte vara tom.";
            return this.formValidation.govPhoneError = true;
        }
        if(input != null && this.numberSpaceChar.test(input)) {
            return this.formValidation.govPhoneError = false;
        } else {
            modalData[0] = "Fel i fält: Telefonnummer (myndighet)";
            modalData[1] = "Fältet får endast innehålla siffror eller karaktärer.";
            return this.formValidation.govPhoneError = true;
        }
    }

    /**
     * Validate government post city 
     * @param input Government post city
     * @param modalData Error modal
     */
    validateGovPostCity(input, modalData = ["", ""]) {
        if(input === null || input === "") {
            modalData[0] = "Fel i fält: Postort (myndighet)";
            modalData[1] = "Fältet får inte vara tom.";
            return this.formValidation.govCityError = true;
        }
        if(input != null && this.numberSpaceChar.test(input)) {
            return this.formValidation.govCityError = false;
        } else {
            modalData[0] = "Fel i fält: Postort (myndighet)";
            modalData[1] = "Fältet får endast innehålla siffror eller karaktärer.";
            return this.formValidation.govCityError = true;
        }
    }

    /**
     * Validate government post number
     * @param input Government post number
     * @param modalData Error modal
     */
    validateGovPostNumber(input, modalData = ["", ""]) {
        if(input === null || input === "") {
            modalData[0] = "Fel i fält: Postnummer (myndighet)";
            modalData[1] = "Fältet får inte vara tom.";
            return this.formValidation.govPostNumberError = true;
        }
        if(input != null && this.numberSpaceChar.test(input)) {
            return this.formValidation.govPostNumberError = false;
        } else {
            modalData[0] = "Fel i fält: Postnummer (myndighet)";
            modalData[1] = "Fältet får endast innehålla siffror eller karaktärer.";
            return this.formValidation.govPostNumberError = true;
        }
    }

    /**
     * Validate project name
     * @param input Project name
     * @param modalData Error modal
     */
    validateCompProject(input, modalData = ["", ""]) {
        if(input === null || input === "") {
            modalData[0] = "Fel i fält: Projekt/Uppdrag";
            modalData[1] = "Fältet får inte vara tom.";
            return this.formValidation.compProjectError = true;
        }
        if(input != null && this.numberSpaceChar.test(input)) {
            return this.formValidation.compProjectError = false;
        } else {
            modalData[0] = "Fel i fält: Projekt/Uppdrag";
            modalData[1] = "Fältet får endast innehålla siffror eller karaktärer.";
            return this.formValidation.compProjectError = true;
        }
    }

    /**
     * Validate government supplier
     * @param input Supplier name
     * @param modalData Error modal
     */
    validateGovSupplier(input, modalData = ["", ""]) {
        if(input === null || input === "") {
            modalData[0] = "Fel i fält: Underleverantör";
            modalData[1] = "Fältet får inte vara tom.";
            return this.formValidation.govSupplierError = true;
        }
        if(input != null && this.numberSpaceChar.test(input)) {
            return this.formValidation.govSupplierError = false;
        } else {
            modalData[0] = "Fel i fält: Underleverantör";
            modalData[1] = "Fältet får endast innehålla siffror eller karaktärer.";
            return this.formValidation.govSupplierError = true;
        }
    }

    /**
     * Validate security chief name
     * @param input Security chief name
     * @param modalData Error modal
     */
    validateCompSecChief(input, modalData = ["", ""]) {
        if(input === null || input === "") {
            modalData[0] = "Fel i fält: Säkerhetsskyddschef";
            modalData[1] = "Fältet får inte vara tom.";
            return this.formValidation.compSecChiefError = true;
        }
        if(input != null && this.numberSpaceChar.test(input)) {
            return this.formValidation.compSecChiefError = false;
        } else {
            modalData[0] = "Fel i fält: Säkerhetsskyddschef";
            modalData[1] = "Fältet får endast innehålla siffror eller karaktärer.";
            return this.formValidation.compSecChiefError = true;
        }
    }

    /**
     * Validate security chief phone
     * @param input Security chief
     * @param modalData Error modal
     */
    validateCompSecChiefPhone(input, modalData = ["", ""]) {
        if(input === null || input === "") {
            modalData[0] = "Fel i fält: Telefonnummer (säkerhetsskyddschef)";
            modalData[1] = "Fältet får inte vara tom.";
            return this.formValidation.compSecChiefPhone = true;
        }
        if(input != null && this.numberSpaceChar.test(input)) {
            return this.formValidation.compSecChiefPhone = false;
        } else {
            modalData[0] = "Fel i fält: Telefonnummer (säkerhetsskyddschef)";
            modalData[1] = "Fältet får endast innehålla siffror eller karaktärer.";
            return this.formValidation.compSecChiefPhone = true;
        }
    }

    /**
     * Validate second security chief name
     * @param input Second security chief name
     * @param modalData Error modal
     */
    validateSecondCompSecChief(input, modalData = ["", ""]) {
        if(input === null || input === "") {
            modalData[0] = "Fel i fält: Biträdande säkerhetsskyddschef";
            modalData[1] = "Fältet får inte vara tom.";
            return this.formValidation.compSecondSecChiefError = true;
        }
        if(input != null && this.numberSpaceChar.test(input)) {
            return this.formValidation.compSecondSecChiefError = false;
        } else {
            modalData[0] = "Fel i fält: Biträdande säkerhetsskyddschef";
            modalData[1] = "Fältet får endast innehålla siffror eller karaktärer.";
            return this.formValidation.compSecondSecChiefError = true;
        }
    }

    /**
     * Validate phonenumber of second security chief
     * @param input Phonenumber of second security chief
     * @param modalData Error modal
     */
    validateSecondCompSecChiefPhone(input, modalData = ["", ""]) {
        if(input === null || input === "") {
            modalData[0] = "Fel i fält: Telefonnummer (biträdande säkerhetsskyddschef)";
            modalData[1] = "Fältet får inte vara tom.";
            return this.formValidation.compSecondSecChiefPhone = true;
        }
        if(input != null && this.numberSpaceChar.test(input)) {
            return this.formValidation.compSecondSecChiefPhone = false;
        } else {
            modalData[0] = "Fel i fält: Telefonnummer (biträdande säkerhetsskyddschef)";
            modalData[1] = "Fältet får endast innehålla siffror eller karaktärer.";
            return this.formValidation.compSecondSecChiefPhone = true;
        }
    }

    /**
     * Validate Security contract option 
     * @param input Option selected
     * @param modalData Error modal
     */
    validateSecContractSelected(input, modalData = ["", ""]) {
        if(input != "levelOne" && input != "levelTwo" && input != "levelThree") {
            modalData[0] = "Fel i fält: Tecknat säkerhetsskyddsavtal";
            modalData[1] = "Ett alternativ måste väljas.";
            return this.formValidation.secContractError = true;
        } else {
            return this.formValidation.secContractError = false;
        }
    }

    /**
     * Validate RK option
     * @param input Option selected
     * @param modalData Error modal
     */
    validateRegisterControl(input, modalData = ["", ""]) {
        if(input != "ja" && input != "nej") {
            modalData[0] = "Fel i fält: Registerkontroll";
            modalData[1] = "Ett alternativ måste väljas.";
            return this.formValidation.rkError = true;
        } else {
            return this.formValidation.rkError = false;
        }
    }

    /**
     * Validate project date (not null) 
     * @param input Date
     * @param modalData Error modal
     */
    validateProjectDate(input, modalData = ["", ""]) {
        if(isNaN(Date.parse(input))) {
            modalData[0] = "Fel i fält: Datum (säkerhetsskyddsavtal)";
            modalData[1] = "Ett datum måste anges.";
            return this.formValidation.projectDateError = true;
        } else {
            return this.formValidation.projectDateError = false;
        }
    }

    /*
    validateSuaName(suaName, modalData = ["", ""]) {
        if(suaName === null  || suaName.trim().length < 2 || suaName === "") {
            modalData[0] = "Fel i fält: SUA-namn";
            modalData[1] = "SUA-namnet måste innehålla minst 2 karaktärer.";
            return this.formValidation.suaNameError = true;
        } 
        if (this.numberSpaceChar.test(suaName)) {
            return this.formValidation.suaNameError = false;
        }
        modalData[0] = "Fel i fält: KontrollorsakSUA-namn";
        modalData[1] = "SUA-namnet får endast innehålla siffror eller karaktärer.";
        return this.formValidation.suaNameError = true;
    }

    validateSuaDate(suaStartDate, suaEndDate, modalData = ["", ""]) {
        
        if((Date.parse(suaStartDate) > Date.parse(suaEndDate)) || suaEndDate === null ||suaStartDate === null) {
            modalData[0] = "Fel i fält: Slutdatum";
            modalData[1] = "Slutdatumet får varken vara tomt eller komma innan startdatumet.";
            return this.formValidation.suaDateError = true;
        } else {
            return this.formValidation.suaDateError = false;
        }
    }

    validateSupplierName(suaSupplier, modalData = ["", ""]) {
        if(suaSupplier === null || suaSupplier === "") {
            modalData[0] = "Fel i fält: Huvudleverantör";
            modalData[1] = "Fältet är tomt.";
            return this.formValidation.suaSupplierError = true;
        }
        if(suaSupplier.trim().length < 2) {
            modalData[0] = "Fel i fält: Huvudleverantör";
            modalData[1] = "Huvudleverantör måste innehålla minst 2 karaktärer.";
            return this.formValidation.suaSupplierError = true;
        } 
        if (this.numberSpaceChar.test(suaSupplier)) {
            return this.formValidation.suaSupplierError = false;
        }
        modalData[0] = "Fel i fält: Huvudleverantör";
        modalData[1] = "Huvudleverantör får endast innehålla siffror eller karaktärer.";
        return this.formValidation.suaSupplierError = true;
    }

    validateSecManagerName(secName, modalData = ["", ""]) {
        if(secName != null && secName.trim().length > 1) {
            return this.formValidation.secManagerNameError = false;
        }
        
        modalData[0] = "Fel i fält: Säkerhetsskyddschef";
        modalData[1] = "Namnet måste vara minst två bokstäver långt för att godkännas.";
        return this.formValidation.secManagerNameError = true;
    }

    validateSecManagerPhone(secPhone, modalData = ["", ""]) {
        if(secPhone === null || secPhone === "" || secPhone === undefined) {
            modalData[0] = "Fel i fält: Telefonnummer (Säkerhetsskyddschef)";
            modalData[1] = "Fältet är tomt.";
            return this.formValidation.secManagerPhoneError = true;
        }

        secPhone = secPhone.match(/[0-9]/g);
        if(secPhone != null && secPhone.length > 3) {
            return this.formValidation.secManagerPhoneError = false;
        } else {
            modalData[0] = "Fel i fält: Telefonnummer (Säkerhetsskyddschef)";
            modalData[1] = "Numret måste vara minst fyra karaktärer långt och får endast bestå av siffror för att godkännas.";
            return this.formValidation.secManagerPhoneError = true;
        }
    }
    */
}